<div id="padding">
    <div id="scrollView" [style.height.px]="[getViewHeight()]">
        <ng-container *ngIf="taskContent; then content; else loading"></ng-container>
        <ng-template #content>
            <pre>{{taskContent}}</pre> 
        </ng-template>
        <ng-template #loading>
            <mat-spinner class="spinner"></mat-spinner>
        </ng-template>
    </div>
</div>